import React from 'react';
import PropTypes from 'prop-types';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';
import Header from './Header';
import FeaturedResource from './FeaturedResource';
import Section from '../../pages/my-network/Section';
import TeamContact from './TeamContact';
import { useUser } from '@lore/auth';
import { useConnect } from '../../../hooks/@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import StewardContact from './StewardContact';

SupportQuestionViewDialog.propTypes = {
  supportQuestion: PropTypes.object.isRequired
};

export default function SupportQuestionViewDialog(props) {
  const { supportQuestion } = props;

  const currentUser = useUser();

  const networkSupportQuestions = useConnect('networkSupportQuestion.find', {
    where: {
      eager: {
        $where: {
          supportQuestionId: supportQuestion.id,
          networkId: currentUser.data.networkId
        }
      }
    }
  });

  if (networkSupportQuestions.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate className="w-screen max-w-screen-md">
        <CloseDialogButton onCancel={props.onCancel} />
        <div className="px-6 pt-14 pb-6">
          <Loader />
        </div>
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-md">
      <CloseDialogButton onCancel={props.onCancel} />
      <div className="px-6 pt-14 pb-6">
        <div className="space-y-8">
          <Header supportQuestion={supportQuestion} />
          <Section
            title="Featured Resource"
            subtitle="Find resources, strategies, and support to bring your ideas to life."
          >
            <FeaturedResource supportQuestion={supportQuestion} />
          </Section>
          {networkSupportQuestions.data.length > 0 && (
            <Section
              title="Looking for local support?"
              subtitle={(
                <>
                  Your stewards are here to help connect you with the right people and
                  local resources and help you bring your ideas to life in your community.
                </>
              )}
            >
              <div className="space-y-2">
                {networkSupportQuestions.data.map(function(networkSupportQuestion) {
                  return (
                    <StewardContact
                      key={networkSupportQuestion.id}
                      networkSupportQuestion={networkSupportQuestion}
                    />
                  );
                })}
              </div>
            </Section>
          )}
          <Section
            title="Connect with the CommunityShare Team"
            subtitle={(
              <>
                Whether you're seeking guidance or resources, exploring new opportunities, or shaping
                your ideas, we're here to connect you to the people and tools you need to make your
                project a success!
              </>
            )}
          >
            <TeamContact supportQuestion={supportQuestion} />
          </Section>
        </div>
      </div>
    </DialogTemplate>
  );
};
